<template>
  <div id="news">
    <!-- all_in -->
    <div class="break_box">
      <Breadcrumb>
        <breadcrumbs></breadcrumbs>
      </Breadcrumb>
    </div>
    <div class="con_all" v-if="!$route.meta.keepAliveSub">
      <div class="con_two">
        <div class="tea_l">
          <div class="tea_nav_title">{{newsTitle}}</div>
          <div class="tea_nav">
            <ul>
              <li v-if="type.homeDisplay === 1" v-for="(type,index) in types" :key="index" :class="on[type.id]" @click="focus(type.id);selectName(type.id);pushToNew();">{{showType(type)}}</li>
            </ul>
          </div>
        </div>
        <div class="tea_r" style="position: relative;">
          <div class="more_box" v-for="(newsitem,index) in hotNews" :key="'hot'+index" v-if="inCurrentPage(index)">
            <a :target="target(newsitem)" :href="href(newsitem)" @click="pushToNewsSub(newsitem, $event)">
              <div class="more_l">
                {{newsitem.createdAt.split(' ')[0]}}
              </div>
              <div class="more_r">
                <span class="nhott">HOT</span>
                <span>{{newsitem.title}}</span>
              </div>
            </a>
            <div class="fix"></div>
          </div>
          <div class="more_box" v-for="(newsitem,index) in normalNews" :key="index" v-if="inCurrentPage(hotNews.length + index)">
            <a :target="target(newsitem)" :href="href(newsitem)" @click="pushToNewsSub(newsitem, $event)">
              <div class="more_l">
                {{newsitem.createdAt.split(' ')[0]}}
              </div>
              <div class="more_r">
                <span>{{newsitem.title}}</span>
              </div>
            </a>
            <div class="fix"></div>
          </div>
          <Spin size="large" fix v-if="spinShow" style="margin-top: 100px;"></Spin>
        </div>
        <div class="fix"></div>
        <div class="pagination-row text-center">
          <Page :current="currentPage" :total="news.length" style="margin-top:20px" :page-size="pagesize" @on-change="changePage"></Page>
        </div>
      </div>
    </div>
    <router-view :newsitem="newsitem" @initNews="initNews" v-if="$route.meta.keepAliveSub"></router-view>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'news',
  data() {
    return {
      spinShow: true,
      allNews: [],
      news: [],
      hotNews: [],
      normalNews: [],
      newsitem: '',
      types: [],
      currentPage: 1,
      pagesize: 10,
      on: { 1: { on: true } },
      locale: sessionStorage.getItem('locale'),
      newsTitle: { CH: '最新消息', EN: 'Latest News' },
      allNewsExec: false,
      typesExec: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.showPage();
      this.initNews();
      this.initTypes();
    },
    initNews() {
      this.getNewsData();
    },
    initTypes() {
      this.getTypesData();
    },
    initNewsitem(newsitem) {
      this.newsitem = newsitem;
    },
    getNewsData() {
      axios.get(API.notice)
        .then(response => {
          this.allNews = response.data.filter(data => {
            return data.trash !== 1　 && data.language.toUpperCase() === this.locale;
          });
          // this.handleReceivedNews();
          this.allNewsExec = true;
          if (this.allNewsExec && this.typesData)
            this.selectName(this.types[0].id);
        })
        .then(() => {
          this.spinShow = false
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getHotNewsData() {
      this.hotNews = this.news.filter(news => {
        return news.isTop;
      })
    },
    getNormalNewsData() {
      this.normalNews = this.news.filter(news => {
        return !news.isTop;
      })
    },
    getTypesData() {
      axios.get(API.code + '?type=2')
        .then(response => {
          this.types = response.data.filter(data => {
            return data.trash !== 1;
          });
          this.typesData = true;
          if (this.allNewsExec && this.typesData)
            this.selectName(this.types[0].id);
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },

    handleReceivedNews() {
      this.allNews.sort((a, b) => {
        let aDate = new Date(a.createdAt),
          bDate = new Date(b.createdAt);
        if (aDate.getTime() < bDate.getTime())
          return 1;
        return -1;
      });
    },

    changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage(index) {
      let currentPage = this.currentPage,
        pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize
    },

    focus(index) {
      this.on = {};
      this.on[index] = { on: true };
    },
    selectName(id) {
      this.currentPage = 1;
      this.news = this.allNews.filter(news => {
        return news.typeId == id;
      });
      this.getHotNewsData();
      this.getNormalNewsData();
    },
    pushToNew() {
      if (this.$route.name === 'news_sub')
        this.$router.push({ name: 'news' });
    },

    pushToNewsSub(newsitem, event) {
      if (!newsitem || newsitem.linkType !== 1) return;
      if (event && event.preventDefault) event.preventDefault();
      this.newsitem = newsitem;
      this.$router.push({ name: 'news_sub', params: { newsid: newsitem.id } });
    },
    target(newsitem) {
      return newsitem.linkType === 2 && newsitem.openMode === 2;
    },
    href(newsitem) {
      if (!newsitem) return undefined;
      if (newsitem.linkType === 2 && newsitem.externalLink)
        return newsitem.externalLink;
      if (newsitem.linkType === 1) {
        const to = { name: 'news_sub', params: { newsid: newsitem.id } }
        if (sessionStorage.getItem('locale') === 'EN') to.query = { L: 'EN' }
        return this.$router.resolve(to).href
      }
      return undefined;
    },



    showPage() {
      this.newsTitle = this.newsTitle[this.locale];
    },
    showType(type) {
      return sessionStorage.locale === 'CH' ? type.nameCh : type.nameEn;
    }
  },
}

</script>
<style lang="scss">
#news {
  a {
    color: #11574F;
  }
  .tea_nav {
    ul {
      li {
        cursor: pointer;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// News.vue?6583e267